import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiFieldText, EuiButton, EuiSpacer, EuiTextColor, EuiTextArea, EuiFormControlLayoutDelimited, EuiIcon, EuiSwitch, EuiBadge} from '@elastic/eui';
import {ComboSociedadesContainer as ComboSociedades} from '../../../components/Combos/Sociedades/container';
import {ComboFuncionesContainer as ComboFunciones} from '../../../components/Combos/Funciones/container';
import {ComboProyectosContainer as ComboProyectos} from '../../../components/Combos/Proyectos/container';
import {ComboObrasContainer as ComboObras} from '../../../components/Combos/Obras/container';
import {ComboSubFuncionesContainer as ComboSubFunciones} from '../../../components/Combos/SubFunciones/container';
import SelectorFecha from '../../../../../shared/components/Combos/Fecha';
import {ListaAdjuntosContainer as ListadoAdjuntos} from '../../../components/Listas/Adjuntos/container';
import { stringToFloat, toDecimalString } from '../../../../../shared/utils/numbers';
import{ CreateFecha, CreateFechaMoment, ToSQL } from '../../../../../shared/utils/fecha';
import { HelpTooltip } from '../../Proyectos/Formulario/help';
import moment from 'moment';
import { PanelInfoBloqueoApp } from '../../../components/Layout/PanelInformativoBloqueo';

const msgObra = <p>{`Se podrá agregar únicamente obras correspondientes a la sociedad `}<strong style={{color:'#30abff'}}>{`Elecnor Servicios y Poryectos`}</strong></p>

export const FormularioEditarPartes = forwardRef((props,ref)=>{
  
  let {onSave,onDownLoad,onRemoveAdjuntos,handleChangeTypeAdjunto,selected, refreshAdjuntos, onClose, user} = props

  let [fecha, setFecha] = useState(CreateFechaMoment(selected.fecha));

  const getMaxHoras = useMemo(()=>{
    if(fecha.month()+1 < 7 || fecha.month()+1 > 8){
        if(moment(fecha).day()===5){
          return (fecha.year()===2021 && fecha.month()+1 < 7) ? 8 :user.horasViernes;
        }else{
          return (fecha.year()===2021 && fecha.month()+1 < 7) ? 8 : user.horasLunesJueves
        }
    }else{
      return user.horasLunesJuevesContinuo
    }
  },[fecha])

  const parseNHoras = (value) => (stringToFloat(value)*getMaxHoras)/100
  const parsePHoras = (value) => (stringToFloat(value)*100)/getMaxHoras
  
  let [sociedad,setSociedad] = useState(selected.idSociedad)
  let [funcion,setFuncion] = useState(selected.idFuncion)
  let [subFuncion,setSubFuncion] = useState(selected.idSubFuncion)
  let [proyecto,setProyecto] = useState(selected.idProyecto)
  let [centroObra, setCentroObra] = useState(selected.codCentroObra);
  let [nHoras, setNhoras] = useState(selected.nHoras.toString())
  let [pHoras, setPhoras] = useState(toDecimalString(parsePHoras(selected.nHoras.toString()),1).replace(',','.'))
  let [desplazado, setDesplazado] = useState(selected.desplazado)
  let [observaciones, setObservaciones] = useState(selected.observaciones)

  const [nAdjuntos, setNAdjuntos] = useState(0)
  
  const onSaveData = () =>{
    const _valueObservaciones = document.getElementsByName('observaciones-form')[0].value;
    let data = {
      idSociedad: sociedad[0].value, 
      idProyecto: (proyecto!==undefined && proyecto.length>0) ? proyecto[0].value : undefined, 
      codCentroObra: (centroObra!==undefined && centroObra!==null && centroObra.length>0) ? centroObra[0].value : undefined, 
      idFuncion: funcion[0].value, 
      idSubFuncion: subFuncion[0].value, 
      fecha: ToSQL(fecha,"-"), 
      nHoras: nHoras && stringToFloat(nHoras),
      desplazado: desplazado,
      offShore: null,
      observaciones: _valueObservaciones===""?null:_valueObservaciones
    }
    
    if(comprobarErrores()){
      onSave && onSave({...selected,...data})
    }
  }

  const isWeekday = (date) => {
    const day = date.day();
    return day !== 0 && day !== 6;
  };

  const comprobarErrores = () => {
    return !isInvalidSociedad && !isInvalidProyecto && !isInvalidFuncion && !isInvalidSubFuncion && !errorHoras;
  }

  useImperativeHandle(
    ref,
    () => ({
        onSaveDataForm(){
          onSaveData()
        }
     })
  )

  const handleRemoveAdjuntos = (idAdjunto,todos)=>{
    let data ={idParte: selected.idParte, idAdjunto: idAdjunto, todosPartes: todos}
    const errorDesplazado = desplazado === true && nAdjuntos === 1
    return onRemoveAdjuntos && onRemoveAdjuntos(data, errorDesplazado);
  }

  const errorHoras = useMemo(() => {return nHoras===undefined || nHoras.trim()==="" || (isNaN(stringToFloat(nHoras))) || stringToFloat(nHoras)>getMaxHoras},[nHoras,getMaxHoras])
  const isInvalidSociedad = useMemo(() => sociedad===undefined || sociedad.length===0,[sociedad])
  const isInvalidProyecto = useMemo(() => (proyecto===undefined || proyecto===null || proyecto.length===0),[proyecto,user]);
  const isInvalidFuncion = useMemo(() => funcion===undefined || funcion===null || funcion.length===0,[funcion])
  const isInvalidSubFuncion = useMemo(() => subFuncion===undefined || subFuncion===null || subFuncion.length===0,[subFuncion])

  const isDisabledProyecto = useMemo(()=>!isInvalidSociedad,[sociedad]);
  const isDisabledCentroObra = useMemo(()=>(!isInvalidProyecto && 
    (!isInvalidSociedad && (sociedad === '00007070' || (sociedad.length===1 && sociedad[0].value.toString()==='00007070')))
  ),[proyecto,sociedad,isInvalidProyecto,isInvalidSociedad]);

  const labelHoras = useMemo(()=>{
    return (
      <span>
      {'Nº Horas Diarias '}
      <HelpTooltip message={`Imputación máxima día (${getMaxHoras} horas)`} position="top" adjust/>
      </span>
    )
  },[getMaxHoras])

  const onChangeHoras = (type, value) =>{
    let calc = 0;
    const valueFormat = value.replace(',','.');
    
    if(type==='p')
    {
      calc = parseNHoras(valueFormat)
      setPhoras(valueFormat.length>3 ? (valueFormat.split('.')[1].length>1 ? valueFormat.slice(0,3) : valueFormat) : valueFormat)
      setNhoras(toDecimalString(calc).replace(',','.'))
    }else{
      calc = parsePHoras(valueFormat)
      setNhoras(valueFormat)
      setPhoras(toDecimalString(calc,0).replace(',','.'))
    }
  }

  const onChangeTypeAdjunto = (adjunto)=>{
    const dataType = {IdAdjunto:adjunto.id, IdTipoAdjunto:adjunto.tipo.idTipoAdjunto};
    handleChangeTypeAdjunto&&handleChangeTypeAdjunto(dataType)
  }

  const getNumberAdjuntos = (nAdjuntos) => {setNAdjuntos(nAdjuntos)}

  const msgDesplazado = <p>{`Marcar la casilla si estás desplazado/a a la hora de prestar el servicio. (Se deberá adjuntar documentación justificativa del viaje).`}
  <br/><strong style={{color:'#30abff'}}>{`Billetes de avión, justificativa de hotel..`}</strong></p>

  const estaFacturadoValidado = useMemo(()=> selected && (selected.facturado || selected.estado>1),[selected])

  const panelInfoFechaBaja = useMemo(()=>{
    const {fechaBaja} = user;
    if(fechaBaja!==null){
      const fechaBajaStr = CreateFecha(fechaBaja);
      return(
        <EuiBadge style={{color:'#006BB4'}} color="#e6f0f8" iconType="iInCircle" iconSide="left">
          {<p>{`Debido a que tienes programada una `}<strong>{`Fecha de Baja el día ${fechaBajaStr}`}</strong>{`, no se podrán crear partes a partir de dicha fecha.`}</p>}
        </EuiBadge>
      )
    }
  },[user])
  
  const errorPanel = useMemo(()=>{
    return !comprobarErrores() ? 
    <EuiBadge style={{color:'#BD271E'}} color="#f8e9e9" iconType="cross" iconSide="left">
      {`Faltan campos por rellenar o tienen errores.`}
    </EuiBadge>
    :null
    },[comprobarErrores])


  const INFO_PANELS = () =>(
    <EuiFlexGroup direction='column' gutterSize='s'>
        <EuiFlexItem><PanelInfoBloqueoApp withClass={false} compress/></EuiFlexItem>
        <EuiFlexItem>{panelInfoFechaBaja}</EuiFlexItem>
        <EuiFlexItem grow={false}>{errorPanel}</EuiFlexItem>
        <EuiFlexItem>
        </EuiFlexItem>
    </EuiFlexGroup>
  )
  
  const labelObras = useMemo(()=>(<span>{`Obras `}<HelpTooltip message={msgObra} position="top" adjust/></span>))
  
  const getComboObras = useMemo(()=>{
    const {partesConObra} = user;
    return (partesConObra)  ? 
                    <EuiFlexItem grow={2}>
                      <EuiFormRow label={labelObras} fullWidth>
                          <ComboObras fullWidth isDisabled={(isDisabledCentroObra && !estaFacturadoValidado) ? false : true} dependency 
                          idProyecto={!isInvalidProyecto ? (Array.isArray(proyecto) ? proyecto[0].value : proyecto) : undefined} 
                          selectedOptions={centroObra} onChange={value => setCentroObra(value)}/>
                      </EuiFormRow>
                    </EuiFlexItem>
            : null
  },[user,centroObra,proyecto,isDisabledCentroObra,isInvalidProyecto,estaFacturadoValidado,setCentroObra,labelObras])

  return (
    <EuiFlexGroup direction='column'>
       <EuiFlexItem grow={false}>{INFO_PANELS()}</EuiFlexItem>
      
      <EuiFlexItem>
        <EuiFlexGroup>
          <EuiFlexItem>
              <EuiFormRow label={`Fecha`} fullWidth>
                <SelectorFecha fullWidth selected={fecha} filterDate={isWeekday} onChange={date => setFecha(date)} readOnly={estaFacturadoValidado}/>
              </EuiFormRow>
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
              <EuiFormRow fullWidth label={labelHoras} isInvalid={errorHoras}>
                <EuiFormControlLayoutDelimited
                  isInvalid={errorHoras}
                  fullWidth
                  prepend={'Nº'}
                  startControl={
                    <EuiFieldText value={nHoras} name="txtNhoras" onChange={e => onChangeHoras('n',e.target.value)} maxLength={4} readOnly={estaFacturadoValidado}/>
                  }
                  delimiter={<EuiIcon type="merge" />}
                  append={'%'}
                  endControl={
                    <EuiFieldText value={pHoras} name="txtPhoras" onChange={e => onChangeHoras('p',e.target.value)}maxLength={3} readOnly={estaFacturadoValidado}/>
                  }
                />
              </EuiFormRow>
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
              <EuiFormRow fullWidth label="Desplazado/a" labelAppend={<HelpTooltip message={msgDesplazado}/>}>
                <EuiSwitch fullWidth name="chkDesplazado" showLabel={false} checked={desplazado} onChange={()=>setDesplazado(!desplazado)}/>
              </EuiFormRow>
            </EuiFlexItem>
        </EuiFlexGroup>
        <EuiSpacer size='s'/>
        <EuiFlexGroup>
          <EuiFlexItem>
            <EuiFormRow label="Sociedad" isInvalid={isInvalidSociedad}  fullWidth>
              <ComboSociedades fullWidth selectedOptions={sociedad} onChange={value =>{setSociedad(value)}} isInvalid={isInvalidSociedad} user={selected.dni} fechaHasta={fecha} isDisabled={estaFacturadoValidado}/>
            </EuiFormRow>
          </EuiFlexItem>
        </EuiFlexGroup>
        <EuiSpacer size='s'/>
        <EuiFlexGroup>
          <EuiFlexItem grow={4}>
              <EuiFormRow label="Proyecto" isInvalid={isInvalidProyecto} fullWidth>
                <ComboProyectos fullWidth isDisabled={(isDisabledProyecto && !estaFacturadoValidado) ? false : true} dependency
                idSociedad={!isInvalidSociedad ? (Array.isArray(sociedad) ? sociedad[0].value : sociedad) : undefined} 
                selectedOptions={proyecto} fechaHasta={fecha} onChange={value => setProyecto(value)} isInvalid={isInvalidProyecto} />
              </EuiFormRow>
          </EuiFlexItem>
          {getComboObras}
        </EuiFlexGroup>
        
        <EuiSpacer size='s'/>
        <EuiFlexGroup>
          <EuiFlexItem style={{maxWidth:'50%'}}>
            <EuiFormRow label="Función" isInvalid={isInvalidFuncion} fullWidth>
            <ComboFunciones fullWidth selectedOptions={funcion} onChange={value => setFuncion(value)} isInvalid={isInvalidFuncion} dni={user.dni} isDisabled={estaFacturadoValidado}/>
            </EuiFormRow>
          </EuiFlexItem>
          <EuiFlexItem style={{maxWidth:'50%'}}>
            <EuiFormRow label="SubFunción" isInvalid={isInvalidSubFuncion} fullWidth>
              <ComboSubFunciones fullWidth dependency idFuncion={!isInvalidFuncion ? (Array.isArray(funcion) ? funcion[0].value : funcion) : undefined} codArea={selected.codArea} idDN={selected.dn}
              isDisabled={(!isInvalidFuncion && !estaFacturadoValidado) ? false : true} selectedOptions={subFuncion} onChange={value => setSubFuncion(value)} isInvalid={isInvalidSubFuncion}/>
            </EuiFormRow>
          </EuiFlexItem>
        </EuiFlexGroup>
        <EuiSpacer size='s'/>
        <EuiFlexGroup>
          <EuiFlexItem>
            <EuiFormRow fullWidth label="Observaciones">
              <EuiTextArea
                fullWidth
                draggable={false}
                compressed
                resize="none"
                rows={2}
                name='observaciones-form'
                defaultValue={observaciones}
                // value={observaciones}
                // onChange={(e) => setObservaciones(e.target.value)}
              />
            </EuiFormRow>
            </EuiFlexItem>
        </EuiFlexGroup>

        <EuiFlexGroup>
          {!estaFacturadoValidado ?
            <EuiFlexItem>
              <EuiFormRow fullWidth label="Adjuntos (click en adjunto para descargar)">
                <ListadoAdjuntos
                  style={{height:"150px", width:"100%!important", maxWidth:"100%", overflowY:"auto"}}
                  fullWidth
                  idParte={selected && selected.idParte}
                  handleDownload={onDownLoad}
                  handleRemove={handleRemoveAdjuntos}
                  getNumberAdjuntos={getNumberAdjuntos}
                  refresh={refreshAdjuntos}
                  onChangeTypeAdjunto={onChangeTypeAdjunto}
                />
              </EuiFormRow>
              </EuiFlexItem>
            :
            <EuiFlexItem><EuiTextColor color='secondary'><p>{`No se pueden editar adjuntos en partes validados o facturados. Adjunta desde el botón Adjuntar de la pantalla.`}</p></EuiTextColor></EuiFlexItem>
          }
        </EuiFlexGroup>
      </EuiFlexItem>
    </EuiFlexGroup>
  )
})
export default FormularioEditarPartes;